export enum PubSubTopics {
    ORDER_PLACED = 'order-placed',
    PAYMENT_PAID = 'payment-paid',
    NOTIFICATION_CREATED = 'notification-created',
  }